import React from 'react';

const Success = () => (
    <div>
        <h1>Success!</h1>
        <p>Your account has been activated.</p>
    </div>
);

export default Success;